export default __webpack_public_path__ + "static/barcelona_code_school_campus_-6-7dd630e1cbfcf3fc4562e0201cf85141.jpg";